import { LayerExpression } from '@datum-group/datum-map/lib/Layer/StyleUtils/resources';

// TODO: создать гибкий инструмент для создания выражений, вынести его из картограмм
export const createInRangeExpression = (
  start: number,
  end: number,
  columnName: string,
) =>
  [
    {
      id: columnName + start,
      fieldName: columnName,
      value: String(start),
      operator: '>=',
    },
    {
      id: columnName + end,
      fieldName: columnName,
      value: String(end),
      operator: '<=',
    },
  ] as [LayerExpression, LayerExpression];
